export const TW_TOKEN = "TW_TOKEN";
export const TW_CONNECTED = "TW_CONNECTED";
export const TW_ROOM_ADD = "TW_ROOM_ADD";
export const TW_ROOM_REMOVE = "TW_ROOM_REMOVE";
